import React from 'react';

import FieldProject, { IFieldProject } from './components/fieldProject';

const outFieldProject = React.forwardRef(<T extends Record<string, any>>({ ...rest }, ref: React.Ref<any>) => {
    return <FieldProject<T> {...rest} ref={ref as any} />;
}) as <T extends Record<string, any>>(props: IFieldProject<T> & { ref?: React.Ref<any> }) => React.JSX.Element;

export default outFieldProject;
